import React from 'react';
import { EmptySlashCircleIcon } from '@/components/icons/EmptySlashCircleIcon';

interface EmptyStateProps {
  title: string;
  subtitle?: string;
  showAdSpace?: boolean;
  className?: string;
  actionLabel?: string;
  onAction?: () => void;
  showIcon?: boolean;
}

/**
 * Circus Daily empty state — Figma 10136:51691 / My Picks 10203:62430
 * Red circle-X, header-01 title, body subtitle, underlined text CTA.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  subtitle,
  className = '',
  actionLabel,
  onAction,
  showIcon = true,
}) => {
  return (
    <div
      data-test-id="empty-state"
      className={`flex flex-col items-center justify-center gap-6 px-0 py-8 text-center ${className}`}
    >
      {showIcon && (
        <span data-test-id="empty-state-icon" className="inline-flex shrink-0">
          <EmptySlashCircleIcon className="size-16 text-primary" />
        </span>
      )}

      <div className="flex w-full flex-col items-center gap-3">
        <h3 data-test-id="empty-state-title" className="font-sans text-header-01 text-white">
          {title}
        </h3>

        {subtitle ? (
          <p
            data-test-id="empty-state-subtitle"
            className="max-w-[342px] font-sans text-body-default text-white"
          >
            {subtitle}
          </p>
        ) : null}

        {actionLabel && onAction ? (
          <button
            type="button"
            data-test-id="empty-state-action"
            onClick={onAction}
            className="min-h-12 border-b border-white pt-3 font-sans text-base font-semibold leading-5 text-white transition-opacity hover:opacity-80"
          >
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default EmptyState;
